import React from "react";

import { TimelineSeparator } from "@mui/lab";

import {
  ActivityConnector,
  ActivityContent,
  ActivityDot,
  ActivityDotCenter,
  ActivityItem,
  ActivityLoading,
  ActivityOppositeContent,
  ActivitySkeletonItem,
} from "./styles";

interface LoadingSkeletonProps {
  isModal?: boolean;
}

export const LoadingSkeleton = ({ isModal }: LoadingSkeletonProps) => {
  const elementsQuantity = isModal ? 4 : 6;
  const heightTitle = 20;
  const heightContent = 32;

  return (
    <>
      {Array.from(Array(elementsQuantity), () => (
        <ActivityItem>
          <ActivityOppositeContent />
          <TimelineSeparator>
            <ActivityDot disabled>
              <ActivityDotCenter disabled />
            </ActivityDot>
            <ActivityConnector disabled />
          </TimelineSeparator>
          <ActivityContent>
            <ActivityLoading container direction="column" alignItems="flex-start">
              <ActivitySkeletonItem variant="text" width="100%" height={heightTitle} />
              <ActivitySkeletonItem variant="text" width="100%" height={heightContent} />
            </ActivityLoading>
          </ActivityContent>
        </ActivityItem>
      ))}
    </>
  );
};
